import { getPageFilesClientSide, getExports } from '../shared/getPageFiles';
export { loadPageFilesClientSide };
export { isErrorFetchingStaticAssets };
const stamp = '__whileFetchingAssets';
async function loadPageFilesClientSide(pageFilesAll, pageId) {
    const pageFilesClientSide = getPageFilesClientSide(pageFilesAll, pageId);
    try {
        await Promise.all(pageFilesClientSide.map((p) => { var _a; return (_a = p.loadFile) === null || _a === void 0 ? void 0 : _a.call(p); }));
    }
    catch (err) {
        if (err) {
            Object.assign(err, { [stamp]: true });
        }
        throw err;
    }
    const { exports, exportsAll, pageExports } = getExports(pageFilesClientSide);
    const pageContextAddendum = {
        exports,
        exportsAll,
        pageExports,
        _pageFilesLoaded: pageFilesClientSide
    };
    return pageContextAddendum;
}
function isErrorFetchingStaticAssets(err) {
    if (!err) {
        return false;
    }
    return err[stamp] === true;
}
